import type { CSSProperties } from "react";

/**
 * Large footer rendition of the UnfoldWin lockup: the same icon file, Lato
 * (`font-wordmark`) Regular and 0.02em tracking as BrandLockup, scaled as one unit to the
 * footer's width (see .lp-wordmark in landing.css). Here the wordmark is set in ink
 * (black); BrandLockup itself, with its two-tone purples, is not used or changed.
 *
 * Hover: the letters lift one after another, "Win" turns the accent purple and the mark
 * turns once. Decorative only (the brand name is already in the page for assistive
 * tech), so nothing depends on hover.
 */
const UNFOLD = ["U", "n", "f", "o", "l", "d"];
const WIN = ["W", "i", "n"];

const letter = (l: string, n: number) => (
  <span key={n} className="lp-letter" style={{ "--n": n } as CSSProperties}>
    {l}
  </span>
);

export function FooterWordmark() {
  return (
    <div className="lp-wordmark-wrap" aria-hidden>
      <div className="lp-wordmark">
        <img src="/images/UnfoldWin - dark.png" alt="" />
        <span className="lp-wordmark-text font-wordmark font-normal tracking-[0.02em]">
          <span className="text-(--lp-ink)">{UNFOLD.map((l, i) => letter(l, i))}</span>
          <span className="lp-win text-(--lp-ink)">{WIN.map((l, i) => letter(l, UNFOLD.length + i))}</span>
        </span>
      </div>
    </div>
  );
}
